// @ts-strict-ignore
import React from 'react'
import { getAuthorName, getAuthorUrl } from '../../utils/contentful'
import { path } from '../../utils/obj'
import ArticleSchema from './article-schema'
import { useDataSelector, useIncludes } from '../helpers/selectors'

const createAuthorObject = (orgName: string, author: string, origin: string) => {
  const name = getAuthorName(author) || orgName
  const url = getAuthorUrl(author)
  const type = name === orgName ? 'Organization' : 'Person'

  const authorObject = { '@type': type, name, url }
  if (url && origin) {
    authorObject.url = `${origin}${url}`
  }

  return authorObject
}

const createImageObject = () => {
  const file = path(['metaImage', 'fields', 'file'])
  if (!file) return {}

  return {
    '@type': 'ImageObject',
    url: file.url,
    width: path(['details', 'image', 'width'], file, ''),
    height: path(['details', 'image', 'height'], file, ''),
  }
}

const ArticleSchemaConnected = ({ page, meta, url }: { page: any; meta: any; url: any }) => {
  const includes = useIncludes()
  const origin = useDataSelector(['location', 'origin'])

  // if page does not have article schema, return empty props
  if (!page.articleSchema) return null

  const { authors = [], publishDate, updatedDate } = url
  const author = includes[authors?.[0]?.sys.id]
  const publisherName = path(['articleSchema', 'publisher', 'name'], meta, meta.brand)

  const props = {
    context: 'http://schema.org',
    type: page.articleSchemaType || 'Article',
    headline: page.title,
    description: page.metaDescription,
    image: createImageObject(page),
    datePublished: publishDate || page.publishedAt || page.sys.createdAt,
    dateModified: updatedDate || page.sys.updatedAt,
    author: createAuthorObject(meta.brand, author, origin),
    publisher: {
      '@type': 'Organization',
      name: publisherName,
      logo: {
        '@type': 'ImageObject',
        url: meta.favicon.href,
        width: '48',
        height: '48',
      },
    },
    mainEntityOfPage: { '@type': 'WebPage', '@id': url.href },
  }

  return <ArticleSchema {...props} />
}

export default ArticleSchemaConnected
